var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.42894V10.0956H3.11111L7 13.9845V1.54005L3.11111 5.42894H0ZM5.44444 5.29672V10.2278L3.75667 8.54005H1.55556V6.9845H3.75667L5.44444 5.29672ZM10.5 7.76227C10.5 6.38561 9.70667 5.20338 8.55556 4.62783V10.8889C9.70667 10.3212 10.5 9.13894 10.5 7.76227ZM8.55556 0.941162V2.54338C10.8033 3.21227 12.4444 5.29672 12.4444 7.76227C12.4444 10.2278 10.8033 12.3123 8.55556 12.9812V14.5834C11.6744 13.8756 14 11.0912 14 7.76227C14 4.43338 11.6744 1.64894 8.55556 0.941162Z",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speaker-icon.0e2639aeac2c0d7b91b3e103996270b3.svg";
export { ForwardRef as ReactComponent };